import './css/main.css'

import Experience from './js/Experience.js'
import Consent from './js/Consent.js'
import LangSwitch from './js/LangSwitch.js'
import initAnalytics from './js/Analytics.js'
import Newsletter from './js/UI/Newsletter.js'

const experience = new Experience(document.getElementById('main-canvas'))
const consent = new Consent({
    waitForIntro: true,
    newTabLinks: true,
    beforeOpen: () => {
        const menu = experience.ui?.menu?.main
        if (menu?.visible && !menu.isAnimating) menu.switchVisiblity()
    },
})
new LangSwitch(experience)
new Newsletter()
initAnalytics()
